import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fRef } from '../../utils/React.js';
import { getThemeClass } from '../Theme/ThemePresentation.js';
import { hostClass } from './Flyout.styles.js';

var defaultProps = {
  innerSpacing: "none",
  preferOpenToLeft: false
};
var FlyoutPresentation = fRef(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    children = props.children,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    ref = props.ref,
    onKeyDown = props.onKeyDown,
    host = props.host,
    openTop = props.openTop,
    transitionState = props.transitionState,
    toggleElement = props.toggleElement,
    toggleContainerElement = props.toggleContainerElement,
    isToggleElmWidth = props.isToggleElmWidth,
    hasTabIndex = props.hasTabIndex,
    stretchBreakpointBu = props.stretchBreakpointBu,
    withGap = props.withGap,
    innerSpacing = props.innerSpacing,
    role = props.role,
    ariaLabel = props.ariaLabel,
    preferOpenToLeft = props.preferOpenToLeft,
    renderCounter = props.renderCounter,
    open = props.open,
    forceRender = props.forceRender,
    hostWidth = props.hostWidth,
    setHostWidth = props.setHostWidth;
  if (typeof document === "undefined") {
    return;
  }
  var toggleElm = toggleContainerElement || toggleElement;
  var styles = {
    top: "0",
    left: "initial",
    right: "initial",
    width: undefined
  };
  // Get the width of the host before first visible render
  setTimeout(function () {
    if (open && renderCounter < 1) {
      forceRender(renderCounter + 1);
      if (host) {
        setHostWidth(host.getBoundingClientRect().width);
      }
    }
  }, 10);
  if (toggleElm) {
    var computedStyle = window.getComputedStyle(toggleElm);
    var paddingRight = parseInt(computedStyle.paddingRight, 10);
    var gap = withGap ? 8 : 0;
    if (host && openTop) {
      styles.top = "".concat((toggleElm === null || toggleElm === void 0 ? void 0 : toggleElm.offsetTop) - (host === null || host === void 0 ? void 0 : host.offsetHeight) - gap, "px");
    } else {
      styles.top = "".concat((toggleElm === null || toggleElm === void 0 ? void 0 : toggleElm.offsetTop) + (toggleElm === null || toggleElm === void 0 ? void 0 : toggleElm.offsetHeight) + gap, "px");
    }
    if (stretchBreakpointBu && window.innerWidth <= stretchBreakpointBu * 4) {
      // On Mobile
      styles.left = "8px";
      styles.right = "8px";
    } else if (preferOpenToLeft) {
      // Opens to left if it has space, if not to right
      if (hostWidth < toggleElm.getBoundingClientRect().left) {
        styles.right = "".concat(toggleElm.offsetParent.offsetWidth - toggleElm.offsetLeft - toggleElm.offsetWidth, "px");
      } else if (host.getBoundingClientRect().width - toggleElement.getBoundingClientRect().width >= toggleElm.getBoundingClientRect().left) {
        styles.left = "".concat(toggleElm.offsetLeft, "px");
      }
    } else {
      // Opens to right if it has space, if not to left
      if (toggleElm.getBoundingClientRect().right + 150 <= window.innerWidth) {
        styles.left = "".concat(toggleElm.offsetLeft, "px");
      }
      // in some cases - for whatever reason - the toggleElm.offsetParent is not available.
      if (toggleElm.offsetParent && toggleElm.getBoundingClientRect().right + 150 > window.innerWidth) {
        styles.right = "".concat(toggleElm.offsetParent.offsetWidth - toggleElm.offsetLeft - toggleElm.offsetWidth + paddingRight, "px");
      }
    }
    if (isToggleElmWidth) {
      styles.width = "".concat(toggleElm.offsetWidth - paddingRight, "px");
    }
  }
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__open-top"), openTop), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__unmounted"), transitionState.unmounted), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__spacing-").concat(innerSpacing), innerSpacing), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__hidden"), transitionState.exited || transitionState.exiting || transitionState.unmounted), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, getThemeClass("elevated"), true), _cleanupClassObject)),
    isStencilHost: isStencilHost,
    ref: ref,
    tabIndex: hasTabIndex !== undefined ? 0 : undefined,
    onKeyDown: onKeyDown,
    style: styles,
    role: role,
    "aria-label": ariaLabel,
    htmlAttrs: {
      "aria-modal": true
    }
  }, children);
}, defaultProps);
FlyoutPresentation.displayName = "FlyoutPresentation";

export { FlyoutPresentation, defaultProps };
